export class ClienteModel {
    cod_cliente	?: number	
    contrato?: string	
    qtd_apt	?: string	
    qtd	?: number	
    data_proposta?: Date	
    dia_venc?: string	
    valor_contrato?: number	
    tratamento?: string	
    coligada?: string	
    cod_banco?: number	
    banco?: string	
    conta?: string	
    canc_cli?: Date	
    tem	?: string	
    nome?: string	
    fatura?: string	
    emite_boleto?: string	
    gera_contas_receber?: string	
    nome_fantasia?: string	
    tipo_cliente?: string	
    nfe	?: string	
    tipo_end?: string	
    end_rps?: string	
    numero?: string	
    complemento?: string	
    bairro?: string	
    cidade?: string	
    estado?: string	
    cep	?: string	
    endereco_chamada?: string	
    numero_chamada?: string	
    complemento_chamada?: string	
    bairro_chamada?: string	
    cidade_chamada?: string	
    estado_chamada?: string	
    cep_chamada?: string	
    endereco_nfe?: string	
    bairro_nfe?: string	
    cidade_nfe?: string	
    cod_cidade?: string	
    ddd	?: string	
    telefone?: string	
    zona?: string	
    cnpj?: string	
    insc?: string	
    cpf?: string	
    rg?: string	
    regiao?: string	
    tipo?: string	
    mes_ria?: string	
    obs?: string	
    status?: string	
    login?: string	
    senha?: string	
    chave?: string	
    home?: string	
    vendedor?: string	
    email?: string	
    email_os?: string	
    valor?: number	
    reajuste?: Date	
    endereco_cobranca?: string	
    numero_cobranca?: string	
    bairro_cobranca?: string	
    complemento_cobranca?: string	
    cidade_cobranca?: string	
    estado_cobranca?: string	
    cep_cobranca?: string	
    administradora?: string	
    texto_nf?: string	
    art?: string	
    mes_art?: Date	
    qtd_texto?: string	
    montadora?: string	
    pmsp?: string	
    vigencias?: string	
    indice?: string	
    text2?: string	
    ano?: string	
    mes_pagamento?: string	
    bonificacao?: string	
    multa?: string	
    aviso?: string	
    aviso1?: string	
    valor_com_desconto?: number	
    conservadora_atual?: string	
    conservadora_anterior?: string	
    status1?: string	
    cabo?: string	
    cabo1?: string	
    nome_nfe?: string	
    mes_reajuste?: string	
    eng?: string	
    crea?: string	
    placa?: string	
    valor_desconto?: number	
    valor_desconto1?: string	
    valor_desconto2?: number	
    num_proc?: string	
    codint?: string
    data_cadastro?: Date	
    dentro?: boolean	
    dia?: string	
    cliriaop?: boolean	
    atendop?: boolean	
    tel?: string	
    fax?: string	
    tipo_contrato?: string	
    cod_filial?: string	
    retem_pis?: string	
    retem_cofins?: string	
    retem_csll?: string	
    retem_inss?: string	
    retem_irrf_serv?: string	
    seq?: string	
    mes_faturar?: string	
    data_cancelamento?: Date	
    data_ria?: Date	
    feito?: string	
    data_manut?: Date	
    mes_qualidade?: string	
    valor_antigo?: number	
    reajuste_anterior?: string	
    motivo?: string	
    concorrente?: string	
    canc_cli_antigo?: string	
    hist?: string	
    tipo_edif?: string	
    tipo_vent?: string	
    apartamento?: string	
    insc_estadual?: string	
    tipo_fat?: string	
    departmento?: string	
    tarifa?: string	
    atualizada?: string	
    bolop?: boolean	
    admop?: boolean	
    reajop?: boolean	
    taxaop?: boolean	
    nfop?: boolean	
    texto_prazo?: Date	
    cobranca?: Date	
    tip_cob?: boolean	
    cod_vendedor?: number	
    comissao?: number	
    cont_adm?: string	
    comis_adm?: number	
    end_adm?: string	
    bai_adm?: string	
    cep_adm?: string
    cid_adm?: string	
    est_adm?: string	
    tel_adm?: string	
    fax_adm?: string	
    ult_fat?: string	
    nome_sindico?: string	
    tel_sindico?: string	
    nasc_sindico?: Date	
    email_sindico?: string	
    nome_zelador?: string	
    tel_zelador?: string	
    nasc_zelador?: Date	
    email_zelador?: string	
    nome_cond1?: string	
    tel_cond1?: string	
    nasc_cond1?: Date	
    email_cond1?: string	
    nome_cond2?: string	
    tel_cond2?: string	
    nasc_cond2?: Date	
    email_cond2?: string	
    conserant?: string	
    pendencia_manut?: string	
    cod_grupo?: string	
    grupo?: string	
    cod_setor?: string	
    setor?: string	
    tipo_doc?: string	
    envio?: string	
    prazo?: string	
    qte_extra?: number	
    retem?: string	
    mensa_peca?: string	
    texto_imposto?: string
    texto_simples?: string	
    site?: string
    media_apto?: number	
    media_elevador?: number	
    tecnico_manut?: string	
    texto?: string	
    baixa?: Date	
    valor_extra?: number	
    pub?: boolean	
    qteelev?: number	
    telcob?: string	
    contcob?: string	
    cons2?: string	
    cons3?: string	
    issreter?: boolean	
    contato_telefonico?: string	
    mes_telemarketing?: string
    reserva_tecnica?: number	
    urgente?: string	
    ultimo_laudo?: Date	
    valor_art?: number	
    texto_contas_receber?: string	
    codigo_anterior?: string	
    inicio?: string	
    texto_desconto?: string	
    faturamento?: string	
    iss?: number	
    icms?: number	
    cofins?: number	
    pis?: number	
    csll?: number	
    irrf?: number	
    irrf_serv?: number	
    irrf_prod?: number	
    inss?: number	
    insc_municipalxxx?: string	
    insc_municipal?: string	
    agendamento?: string	
    ie?: string	
    correspondencia?: string	
    email_boleto?: string
    teste_manut?: string	
    assinatura?: string	
    qtd_plataforma?: number	
    qtd_escada?: number	
    email_teste?: string	
    origem_contratacao?: string	
    latitude?: string	
    longitude?: string	

    //USADO EM TEMPO REAL
    filtro_data_inicial?: Date
    filtro_data_final?: Date

    endereco_imagem?: string
    endereco_imagem1?: string
    visita?: string
    resolvido?: string
    data?: Date

    longitude_web?: number
    latitude_web?: number

    check_sem_chamado?:boolean
    check_com_tecnico?:boolean
    check_sem_tecnico?:boolean

}